import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ImageDirective } from 'Angular/features/directives/image/image.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [ImageDirective],
    exports: [ImageDirective],
})
export class ImageModule {}
